import React from 'react';
import './index.css';
import { render } from 'react-dom';
import { AppRouter } from './AppRouter';
import { HelmetProvider } from 'react-helmet-async';
// Set page title
document.title = 'Fifth Door';
render(<HelmetProvider data-id="element-119">
    <AppRouter data-id="element-120" />
  </HelmetProvider>, document.getElementById('root'));